/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTrialStatus } from '../../models/api-response-trial-status';

export interface GetTrialStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  companyId: string;
}

export function getTrialStatus(http: HttpClient, rootUrl: string, params: GetTrialStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTrialStatus>> {
  const rb = new RequestBuilder(rootUrl, getTrialStatus.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTrialStatus>;
    })
  );
}

getTrialStatus.PATH = '/v1/api/ui/company/trial-status/{companyId}';
